import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AboutComponent } from "../about/about.component";
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [MatButtonModule, AboutComponent, RouterModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

}
